import { useParams } from 'react-router-dom'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { getIdWithPrefix } from 'utils/pathUtils'
import { useGetLodging } from 'services/places'
import LoadingScreen from 'components/Layout/LoadingScreen'
import useDocumentTitle from 'components/useDocumentTitle'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import {
  MobileCompanyPageShell,
  MobileCompanyNotFound,
} from 'components/MobileCompanyPage/MobileCompanyPageShell'
import { buildLodgingPageContent } from './companyTypeData'

export function MobileLodgingPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const lodgingID = urlParams?.lodging_id
    ? getIdWithPrefix(
        urlParams.lodging_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Lodging]
      )
    : undefined

  const { data, isLoading } = useGetLodging(lodgingID)
  const { enableLodgingHotelAmenities } = useFeatureFlagService()

  // Shared derivation — same stats/fields as the desktop NewLodgingPage.
  const content = buildLodgingPageContent(data, {
    includeAmenities: enableLodgingHotelAmenities,
  })
  useDocumentTitle(isLoading ? 'Loading...' : content.documentTitle)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!data || !content.contactCompanyId) {
    return <MobileCompanyNotFound label="Lodging not found" />
  }

  return (
    <MobileCompanyPageShell
      contactCompanyId={content.contactCompanyId}
      companyName={content.header.name}
      domain={content.header.domain}
      locationCount={content.doorsCount}
      summaryContent={content.summaryContent}
      locationDetailsContent={content.locationDetailsContent}
    />
  )
}
